import React, { useState } from 'react';
import _ from 'underscore';
import moment from 'moment-timezone';
import { humanize, titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import CargomaticModal from 'components/v2/modal';
import CargomaticSelect from 'components/v2/select';
import { onHoldReasons } from './onHoldHelper';
import ShipmentDetailDateItem from './details/ShipmentDetailDateItem';
import ShipmentDetailValueItem from './details/ShipmentDetailValueItem';

const ShipmentOnHoldModal = (props) => {
  const { setShowHoldModal, timezone, onSave, loading } = props;
  const [hold, setHold] = useState(props.hold);
  const { t } = useTranslation();
  function onHoldChange(key, value) {
    const update = { ...hold };
    update[key] = value;
    setHold({ ...update });
  }

  return (
    <CargomaticModal
      style={{ top: '15%' }}
      dialogClassName="rounded-lg"
      title={
        <div>
          <i className="fa fa-ferry" />
          <span>{t('EDIT_HOLD')}</span>
        </div>
      }
      showHeader
      show
      onHide={() => setShowHoldModal(false)}
      body={
        <div className="p-4 space-y-4">
          <CargomaticSelect
            className="w-48 mr-8"
            label={t('REASON_CODE')}
            info={t('SELECT_REASON_CODE_FOR_HOLD')}
            caption={t('SELECT_REASON_CODE')}
            items={_.sortBy(onHoldReasons, (item) => {
              return item.name;
            })}
            showCaption
            valueKey="value"
            textKey="name"
            value={hold.type}
            onSelect={(item) => onHoldChange('type', item.value)}
          />
          <div className="flex pt-2">
            <div className="w-1/2">
              <ShipmentDetailDateItem
                className="mb-4 sm:col-span-1"
                title={t('REPORTED_AT')}
                key="reportedAt"
                heapClassName="shipment-holds-editReportedAt heap"
                value={hold.resolved_at}
                editable
                onSave={(value) =>
                  onHoldChange(
                    'reported_at',
                    moment(value).tz(timezone).toISOString(),
                  )
                }
              />
            </div>
            <div className="w-1/2">
              <ShipmentDetailDateItem
                className="mb-4 sm:col-span-1"
                title={t('RESOLVED_AT')}
                key="resolvedAt"
                heapClassName="shipment-holds-editResolvedAt heap"
                value={hold.resolved_at}
                editable
                onSave={(value) =>
                  onHoldChange(
                    'resolved_at',
                    moment(value).tz(timezone).toISOString(),
                  )
                }
              />
            </div>
          </div>
          <ShipmentDetailValueItem
            rows={4}
            title={t('ADDITIONAL_DETAILS')}
            value={hold.remarks}
            editable
            onSave={(value) => onHoldChange('remarks', value)}
          />
          <div className="flex justify-end border-t border-solid pt-4">
            <button
              className="button button-green"
              onClick={() => onSave(hold)}
            >
              <div className="flex min-w-8">
                {titleize(t('SAVE'))}
                <div>
                  {loading && <i className="fa fa-spinner fa-spin px-1" />}
                </div>
              </div>
            </button>
            <button
              className="button button-secondary"
              onClick={() => setShowHoldModal(false)}
            >
              {t('CANCEL')}
            </button>
          </div>
        </div>
      }
    />
  );
};

export default ShipmentOnHoldModal;
